import { TripType } from '@fcom/core/constants';

export const TripTypeMapping = {
  [TripType.ONEWAY]: 'oneWay',
  [TripType.RETURN]: 'return',
  [TripType.MULTICITY]: 'multiCity',
};
